import Vue from 'vue'
import VueRouter from 'vue-router'

const Index = () => import('@/views/index') // 首页
const MenuMoreTest =  () => import('@/views/index/menuMoreTest'); //首页加载更多
const Notice = () => import('@/views/index/notice'); // 公告栏
const Policy = () => import('@/views/index/test/policy'); //政策法规
const shieldtest = () => import('@/views/index/test/shieldtest'); //手机盾加签
const Train = () => import('@/views/index/test/train'); //培训
const Kefu = () => import('@/views/index/kefu'); //客服
const Unseal = () => import('@/views/index/unseal'); //解封
const NoticeDetail1 = () => import('@/views/index/noticeDetail1'); //公告栏详情1
const PolicyDetail = () => import('@/views/index/test/policyDetail'); //政策法规详情
const topicDetail = () => import('@/views/index/topicDetail'); //公告栏详情1
const newTopicDetail = () => import('@/views/index/newTopicDetail'); //公告栏详情1
const mobilephoneshield = () => import('@/views/index/mobilephoneshield'); //手机盾功能介绍
const Application = () => import('@/views/index/application'); //最新最热应用
const Downloadapp = () => import('@/views/downloadapp/index'); //下载app页面
const scanfailinfo = () => import('@/views/index/scanfailinfo'); //公告栏详情1
const htmlTest = () => import('@/views/test/htmlTest'); //页面跳转异常测试页面
const apiTest = () => import('@/views/test/apiTest'); //后台api请求异常测试页面
const downloadTest = () => import('@/views/test/downloadTest'); //页面下载-测试页面
const openappTest = () => import('@/views/test/openappTest'); //页面下载-测试页面
const authentication = () => import('@/views/test/authentication');//认证测试页面
const authenticationone = () => import('@/views/test/authenticationone');//认证测试页面成功
const NewAuthentication = () => import('@/views/test/NewAuthentication');//认证测试页面(新)
const Opinion = () => import('@/views/index/opinion');//意见或建议
const menuAll = () => import('@/views/menu/menuAll');//全部菜单
const menuEnterprise = () => import('@/views/menu/menuEnterprise');//企业菜单
const menuPersonal = () => import('@/views/menu/menuPersonal');//个人菜单
const menuFinance = () => import('@/views/menu/menuFinance');//个人菜单

// 找回用户名
const resetNameIndex = resolve =>
  require(['@/views/restname/index'], resolve); //找回用户名入口
const restNamelegalperson = resolve =>
  require(['@/views/restname/legalperson'], resolve); //找回用户名入口
const restNameVerify = resolve =>
  require(['@/views/restname/restname'], resolve); //找回用户名方式
const swRestNameEnd = resolve =>
  require(['@/views/restname/success'], resolve); //找回用户名成功

// 注册
const swuserregisterIndex = resolve =>
  require(['@/views/userregister/swuserregisterIndex'], resolve); //个人用户入口
const swuserregister = resolve =>
  require(['@/views/userregister/swuserregister'], resolve); //个人用户注册
const swlegalperson = resolve =>
  require(['@/views/userregister/swlegalperson'], resolve); //法人用户注册
const swuserregpsd = resolve =>
  require(['@/views/userregister/swuserregpwd'], resolve); //设置密码
const swuserregpsdend = resolve =>
  require(['@/views/userregister/swuserregpsdend'], resolve); //设置密码成功
const optionText = resolve =>
  require(['@/views/userregister/optionText'], resolve); //操作说明
const agreementUser = resolve =>
  require(['@/views/userregister/agreement/user'], resolve); //用户协议
const agreementPri = resolve =>
  require(['@/views/userregister/agreement/privacy'], resolve); //隐私协议

// 密码
const swforgotpsdIndex = resolve =>
  require(['@/views/restpwd/index'], resolve); // 忘记密码入口
const swforgotverify = resolve =>
  require(['@/views/restpwd/restverify'], resolve); // 安全验证方式
const swforgotpsd = resolve =>
  require(['@/views/restpwd/restpwd'], resolve); // 重置密码
const swforgotend = resolve =>
  require(['@/views/restpwd/success'], resolve); // 重置密码成功





/**
* 废弃菜单
*/
const menumore = () => import('@/views/index/menuMore');//旧菜单




Vue.use(VueRouter)
let status = false
let str = window.location.href
let index = str.indexOf("app.singlewindow.cn")
let index1 = str.indexOf("swapp.singlewindow.cn")
if (index != -1 || index1 != -1) {
  status = true
} else {
  status = false
}
const routes = [
  {
    path: '/swdesk',
    name: 'index',
    component: Index,
    //redirect:'/index',
    meta: {
      keepAlive: false,// 不要缓存
      refreshFlag: true
    }
  },
  {
    path: '/menuAll',
    name: 'menuAll',
    meta: {
      refreshFlag: true,
      keepAlive: false,// 不要缓存
    },
    component: menuAll
  },
  {
    path: '/menuEnterprise',
    name: 'menuEnterprise',
    meta: {
      refreshFlag: true,
      keepAlive: false,// 不要缓存
    },
    component: menuEnterprise
  },
  {
    path: '/menuPersonal',
    name: 'menuPersonal',
    meta: {
      refreshFlag: true,
      keepAlive: false,// 不要缓存
    },
    component: menuPersonal
  },
  {
    path: '/menuFinance',
    name: 'menuFinance',
    meta: {
      refreshFlag: true,
      keepAlive: false,// 不要缓存
    },
    component: menuFinance
  },
  {
    path: '/menuMoreTest',
    name: 'menuMoreTest',
    meta: {
      refreshFlag: true
    },
    component: MenuMoreTest
  },
  {
    path: '/menuMore',
    name: 'menuMore',
    meta: {
      refreshFlag: true
    },
    component: menumore
  },
  {
    path: '/application',
    name: 'application',
    component: Application
  },
  {
    path: '/notice',
    name: 'notice',
    component: Notice
  },
  {
    path: '/policy',
    name: 'policy',
    component: Policy
  },
  {
    path: '/train',
    name: 'train',
    component: Train
  }, {
    path: '/kefu',
    name: 'kefu',
    component: Kefu
  }, {
    path: '/unseal',
    name: 'unseal',
    component: Unseal
  }, {
    path: '/topicDetail',
    name: 'topicDetail',
    meta: {
      refreshFlag: true
    },
    component: topicDetail
  },
  {
    path: '/policy/detail',
    name: 'policyDetail',
    component: PolicyDetail
  },
  {
    path: '/notice/detail1',
    name: 'noticeDetail1',
    component: NoticeDetail1
  },
  {
    path: '/test/shieldtest',
    name: 'shieldtest',
    component: shieldtest
  },
  {
    path: '/test/htmlTest',
    name: 'htmlTest',
    component: htmlTest
  },
  {
    path: '/test/apiTest',
    name: 'apiTest',
    component: apiTest
  },
  {
    path: '/downloadapp',
    name: 'downloadapp',
    component: Downloadapp,
    meta: {
      title: status ? "掌上单一窗口下载页" : '掌上单一窗口（测试版）下载页',
      keepAlive: false,// 不要缓存
      refreshFlag: true
    }
  },
  {
    path: '/scanfailinfo',
    name: 'scanfailinfo',
    component: scanfailinfo,
  },



  {
    path: '/test/authentication',
    name: 'authentication',
    component: authentication,
  },
  {
    path: '/test/authenticationone',
    name: 'authenticationone',
    component: authenticationone,
  },
  {
    path: '/test/NewAuthentication',
    name: 'NewAuthentication',
    component: NewAuthentication,
  },
  {
    path: '/test/downloadTest',
    name: 'downloadTest',
    component: downloadTest,
  },
  {
    path: '/test/openappTest',
    name: 'openappTest',
    component: openappTest,
  },
  {
    path: '/newTopicDetail',
    name: 'newTopicDetail',
    component: newTopicDetail,
  },
  {
    path: '/mobilephoneshield',
    name: 'mobilephoneshield',
    meta: {
      refreshFlag: true,
      keepAlive: false,// 不要缓存
    },
    component: mobilephoneshield,
  },
  {
    path: '/opinion',
    name: 'opiniom',
    component: Opinion,
    //redirect:'/index',
    meta: {
      keepAlive: false,// 不要缓存
      refreshFlag: true
    }
  },

  {
    path: '/swforgotpsdIndex',//找回密码入口
    name: 'swforgotpsdIndex',
    component: swforgotpsdIndex,
    meta: {
      keepAlive: false, // 要缓存
      refreshFlag: true
    }
  },
  {
    path: '/swforgotend',//找回密码成功
    name: 'swforgotend',
    component: swforgotend,
    meta: {
      keepAlive: true, // 要缓存
      refreshFlag: true
    }
  },
  {
    path: '/swforgotpsd',//重置密码
    name: 'swforgotpsd',
    component: swforgotpsd,
    meta: {
      keepAlive: true, // 要缓存
      refreshFlag: true
    }
  },
  {
    path: '/swforgotverify',//找回密码验证
    name: 'swforgotverify',
    component: swforgotverify,
    meta: {
      keepAlive: false, // 要缓存
      refreshFlag: true
    }
  },
  {
    path: '/resetNameIndex', //找回用户名入口
    name: 'resetNameIndex',
    component: resetNameIndex,
    meta: {
      keepAlive: true, // 要缓存
      refreshFlag: true
    }
  },
  {
    path: '/restNamelegalperson', //法人找回用户名
    name: 'restNamelegalperson',
    component: restNamelegalperson,
    meta: {
      keepAlive: true, // 要缓存
      refreshFlag: true
    }
  },
  {
    path: '/restNameVerify', //找回用户名方式
    name: 'restNameVerify',
    component: restNameVerify,
    meta: {
      keepAlive: true, // 要缓存
      refreshFlag: true
    }
  },
  {
    path: '/swRestNameEnd', //找回用户名成功
    name: 'swRestNameEnd',
    component: swRestNameEnd,
    meta: {
      keepAlive: true, // 要缓存
      refreshFlag: true
    }
  },
  {
    path: '/swuserregisterIndex', //注册入口
    name: 'swuserregisterIndex',
    component: swuserregisterIndex,
    meta: {
      keepAlive: true, // 要缓存
      refreshFlag: true
    }
  },
  {
    path: '/swuserregister', //个人用户注册
    name: 'swuserregister',
    component: swuserregister,
    meta: {
      keepAlive: true, // 要缓存
      refreshFlag: true
    }
  }, {
    path: '/swlegalperson', //法人注册
    name: 'swlegalperson',
    component: swlegalperson,
    meta: {
      keepAlive: true, // 要缓存
      refreshFlag: true
    }
  },
  {
    path: '/swuserregpsd', //注册设置用户名密码
    name: 'swuserregpsd',
    component: swuserregpsd,
    meta: {
      keepAlive: true, // 要缓存
      refreshFlag: true
    }
  },
  {
    path: '/swuserregpsdend', //注册成功
    name: 'swuserregpsdend',
    component: swuserregpsdend,
    meta: {
      keepAlive: true, // 要缓存
      refreshFlag: true
    }
  },
  {
    path: '/optionText', //操作说明
    name: 'optionText',
    component: optionText,
    meta: {
      keepAlive: true, // 要缓存
      refreshFlag: true
    }
  },
  {
    path: '/agreementUser', //用户协议
    name: 'agreementUser',
    component: agreementUser,
    meta: {
      keepAlive: true, // 要缓存
      refreshFlag: true
    }
  },
  {
    path: '/agreementPri', //操作说明
    name: 'agreementPri',
    component: agreementPri,
    meta: {
      keepAlive: true, // 要缓存
      refreshFlag: true
    }
  },


]
console.log('routes.length');
console.log(routes.length);
const router = new VueRouter({
  mode: 'hash',
  //mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// router.beforeEach((to, from, next) => {
//   let url = window.location.href;
//   if (url.includes('?from=')) { // 判断是否携带了 from 参数，这一步灵活变通，只要能判断出是从微信分享链接进来的就 OK
//     url = url.replace(/dist.+.#/, 'dist/#'); // 利用正则表达式去掉微信携带的 ?from=singlemessage&isappinstalled=0 这串参数，如果这串参数对于你当前的页面有用处的话，可以重新拼接到你正常的链接后面去
//     window.location.href = url; // 重定向到正常链接
//   }
// })

export default router
